import type {SelectableItemWithAudio} from '@Panels/ai-subtitle-panel/ai-subtitle-panel.types';
import type {RefObject} from 'react';

export const AI_SUBTITLES_GENERATION_LOADING_KEY = 'ai-subtitle-generation';

export interface AiSubtitleGeneratingProps {
  scrollableContainerRef: RefObject<HTMLDivElement | null>;
  items: Array<SelectableItemWithAudio>;
  onRetry(itemId: string): Promise<void>;
  results: Record<string, AiSubtitleItemResult>;
  isMobile?: boolean;
  isOpenedInContextMenu?: boolean;
}

export enum AiSubtitleItemResult {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  RETRY = 'RETRY',
  LOADING = 'LOADING',
}
